import { render, staticRenderFns } from "./observadores_panel.vue?vue&type=template&id=ad607536&"
import script from "./observadores_panel.vue?vue&type=script&lang=js&"
export * from "./observadores_panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad607536')) {
      api.createRecord('ad607536', component.options)
    } else {
      api.reload('ad607536', component.options)
    }
    module.hot.accept("./observadores_panel.vue?vue&type=template&id=ad607536&", function () {
      api.rerender('ad607536', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/crud/observadores_panel.vue"
export default component.exports